import React, { useState } from "react";
import TableModal from "./TableModal";

const Table = ({ customComponent, onChange, isActive, isDisabled }) => {
	const [tableModal, setTableModal] = useState(false);

	const addTable = (rows, cols) => {
		if (onChange) onChange(rows, cols);
	};

	return (
		<>
			{tableModal && (
				<TableModal
					tableModal={tableModal}
					setTableModal={setTableModal}
					createTable={addTable}
				/>
			)}
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={() => setTableModal(true)}
				title="Add Table"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-table" />}
			</button>
		</>
	);
};

export default Table;
